import { getListActions, getCreateActions, getReadActions, getUpdateActions } from '../../../helpers/actionCreatorCreator';
import { FAILURE, REQUEST, SUCCESS } from '../../../helpers/actionTypeCreator';
import { CRUDTypes, ListDataItems } from '../../../helpers/CRUDTypes';
import { AgrupacionI } from '../AgrupacionesI';

enum AgrupacionesTypes {
    GET_AGRUPACIONES = 'agrupaciones/GET_AGRUPACIONES',
    GET_AGRUPACION = 'agrupaciones/GET_AGRUPACION',
    CREATE_AGRUPACION = 'agrupaciones/CREATE_AGRUPACION',
    UPDATE_AGRUPACION = 'agrupaciones/UPDATE_AGRUPACION',
    DELETE_AGRUPACION = 'agrupaciones/DELETE_AGRUPACION',
    RESET = 'agrupaciones/RESET'
}

export const {
    getAgrupacionesStart,
    getAgrupacionesSuccess,
    getAgrupacionesError,
} = getListActions('Agrupaciones', AgrupacionesTypes.GET_AGRUPACIONES);
export const {
    getAgrupacionStart,
    getAgrupacionSuccess,
    getAgrupacionError,
} = getReadActions('Agrupacion', AgrupacionesTypes.GET_AGRUPACION);
export const {
    createAgrupacionStart,
    createAgrupacionSuccess,
    createAgrupacionError,
} = getCreateActions('Agrupacion', AgrupacionesTypes.CREATE_AGRUPACION);
export const {
    updateAgrupacionStart,
    updateAgrupacionSuccess,
    updateAgrupacionError,
} = getUpdateActions('Agrupacion', AgrupacionesTypes.UPDATE_AGRUPACION);

export const resetAgrupacion = () => ({
    type: AgrupacionesTypes.RESET,
});

const initialState = {
    loading: false,
    error: null,
    list: [],
    totalItems: 0,
    element: null,
    updating: false,
    disenios: {
        list: [],
        loading: false,
        updating: false,
        actual: null,
        error: null,
    },
};

const reducer = (
    state = initialState,
    { type, payload }: CRUDTypes<AgrupacionI>
) => {
    switch (type) {
        case REQUEST(AgrupacionesTypes.GET_AGRUPACIONES):
            return {
                ...state,
                loading: true,
                error: null,
            };
        case REQUEST(AgrupacionesTypes.GET_AGRUPACION):
        case REQUEST(AgrupacionesTypes.CREATE_AGRUPACION):
        case REQUEST(AgrupacionesTypes.UPDATE_AGRUPACION):
        case REQUEST(AgrupacionesTypes.DELETE_AGRUPACION):
            return {
                ...state,
                error: null,
                updating: true,
            };
        case FAILURE(AgrupacionesTypes.GET_AGRUPACIONES):
        case FAILURE(AgrupacionesTypes.GET_AGRUPACION):
        case FAILURE(AgrupacionesTypes.CREATE_AGRUPACION):
        case FAILURE(AgrupacionesTypes.UPDATE_AGRUPACION):
        case FAILURE(AgrupacionesTypes.DELETE_AGRUPACION):
            return {
                ...state,
                loading: false,
                updating: false,
                error: payload,
            };
        case SUCCESS(AgrupacionesTypes.GET_AGRUPACIONES):
            return {
                ...state,
                loading: false,
                list: (payload as ListDataItems<AgrupacionI>).data,
                totalItems: (payload as ListDataItems<AgrupacionI>).totalItems,
            };
        case SUCCESS(AgrupacionesTypes.GET_AGRUPACION):
        case SUCCESS(AgrupacionesTypes.CREATE_AGRUPACION):
        case SUCCESS(AgrupacionesTypes.UPDATE_AGRUPACION):
            return {
                ...state,
                updating: false,
                element: payload,
            };
        case SUCCESS(AgrupacionesTypes.DELETE_AGRUPACION):
                return {
                ...state,
                updating: false,
                element: null,
            };
        case REQUEST(AgrupacionesTypes.RESET):
            return {
                ...state,
                disenios: {
                    list: [],
                    loading: false,
                    updating: false,
                    actual: null,
                    error: null,
                },
            };
        default:
            return state;
        }
}

export default reducer;